import React from "react";
import Table from "./index";

export default function ReportTable(props) {
  return <Table {...props} tableVariant="report"/>;
}
